@if (!showPreviewEmail) {
  <div class="solicitation" data-test-id="send-solicitation-dialog-preview-email">
    <div class="solicitation-header" data-test-id="send-solicitation-dialog-header">
      <div class="solicitation-header-title">
        <h2 data-test-id="send-solicitation-dialog-title">New email from</h2>
        <div class="basicInput">
          <select
            class="basicInput__input"
            data-test-id="send-solicitation-dialog-sender"
            [(ngModel)]="solicitationService.replyToEmail"
          >
            @for (email of allUserEmails; track email) {
              <option data-test-id="send-solicitation-dialog-sender-option" [ngValue]="email">
                {{ email.email }}
              </option>
            }
          </select>
        </div>
        <h2 data-test-id="send-solicitation-dialog-title-expert-email-count">
          to {{ solicitationService.recipientCount }} experts ({{ solicitationService.emailCount }} emails)
        </h2>
      </div>
      <mat-icon class="close-icon" data-test-id="send-solicitation-dialog-close" (click)="dialogRef.close()">
        close
      </mat-icon>
    </div>
    <div class="solicitation-recipients" data-test-id="send-solicitation-dialog-recipients">
      <app-recipient-list></app-recipient-list>
    </div>
    <div class="basicInput subject-input flex flex-col gap-2.5">
      @if (!editingTemplate) {
        <input
          placeholder="subject"
          type="text"
          ngDefaultControl
          class="basicInput__input"
          data-test-id="send-solicitation-dialog-subject"
          [(ngModel)]="solicitationService.subject"
        />
      }
      @if (!editingTemplate) {
        <input
          placeholder="preheader"
          type="text"
          ngDefaultControl
          class="basicInput__input"
          data-test-id="send-solicitation-dialog-preheader"
          [(ngModel)]="solicitationService.preheader"
        />
      }
    </div>
    <div class="solicitation-body">
      <div [className]="sideMenuToShow ? 'show-menu-div' : 'hide-menu-div'">
        @if (sideMenuToShow === 'templates') {
          <app-template-menu
            data-test-id="send-solicitation-dialog-template-menu"
            [initSearchTerm]="initSearchTerm"
            [filteredTemplates]="filteredTemplates"
            (filterTemplatesSignal)="filterTemplates($event)"
            (openTemplateSignal)="openTemplate($event)"
            (openEditTemplateFormSignal)="openEditTemplateForm($event)"
            (openNewTemplateFormSignal)="openNewTemplateForm()"
            (closeMenuSignal)="handleMenuClose()"
            (duplicateTemplateSignal)="duplicateTemplate($event)"
          >
          </app-template-menu>
        }
        @if (sideMenuToShow === 'keys') {
          <app-key class="key-menu" (closeMenuSignal)="handleMenuClose()"> </app-key>
        }
      </div>
      <div #editor class="editor">
        <pre class="ngx-pre">
          <pre class="ngx-pre">
            @if (solicitationService.activeTemplate) {
              <textarea class="editor-textarea" id="editor-1" ngDefaultControl data-test-id="send-solicitation-dialog-body"
              [(ngModel)]="solicitationService.activeTemplate.content"></textarea>
            }
          </pre>
        </pre>
        <div #formContainer class="template-form-container">
          @if (showTemplateForm) {
            <app-template-form
              class="template-menu"
              [inputTemplateFormData]="templateFormData"
              (refreshTemplateMenuSignal)="initialiseViewChange()"
              (closeFormSignal)="closeTemplateForm()"
            >
            </app-template-form>
          }
        </div>
      </div>
    </div>
    <div class="solicitation-footer">
      <div class="button-group">
        <button class="button button--secondary" (click)="toggleKeys()">
          <mat-icon class="button-icon" data-test-id="send-solicitation-dialog-lookup-keys"> vpn_key </mat-icon>
          <span data-test-id="send-solicitation-dialog-lookup-keys-label"> Lookup keys </span>
        </button>
        <button class="button button--secondary" title="Templates" (click)="toggleTemplates()">
          <mat-icon class="button-icon" data-test-id="send-solicitation-dialog-templates">
            library_books_outline
          </mat-icon>
          <span data-test-id="send-solicitation-dialog-templates-label"> Templates </span>
        </button>
      </div>
      <div class="button-group">
        <button
          class="button button--secondary"
          data-test-id="send-solicitation-dialog-cancel"
          [disabled]="previewEmail"
          (click)="dialogRef.close()"
        >
          Cancel
        </button>
        <button
          class="button button--primary"
          data-test-id="send-solicitation-dialog-submit"
          (click)="createAndDisplayPreviewEmail()"
        >
          Send all
        </button>
      </div>
    </div>
    <div class="preview noselect" [style]="{ display: !previewEmail ? 'none' : 'block' }">
      @if (previewEmail) {
        <section>
          <div class="message">
            <span>
              <mat-icon>warning</mat-icon>
              <h5 data-test-id="send-solicitation-dialog-preview-info-message">
                This is a preview of the email that you are going to send out.
              </h5>
            </span>
            <mat-icon
              class="pull-right"
              data-test-id="send-solicitation-dialog-preview-close"
              (click)="clearPreviewEmail()"
            >
              clear
            </mat-icon>
          </div>
          <div class="inner-preview-container">
            <div class="left" data-test-id="send-solicitation-dialog-preview-recipients-label">Recipients</div>
            <div class="right" data-test-id="send-solicitation-dialog-preview-recipients">
              <app-recipient-list></app-recipient-list>
            </div>
          </div>
          <div class="inner-preview-container">
            <div class="left topBorder" data-test-id="send-solicitation-dialog-preview-subject-label">Subject</div>
            <div class="right topBorder" data-test-id="send-solicitation-dialog-preview-subject">
              {{ previewEmail.subject }}
            </div>
          </div>
          @if (previewPreheader) {
            <div class="inner-preview-container">
              <div class="left topBorder" data-test-id="send-solicitation-dialog-preview-preheader-label">
                Preheader
              </div>
              <div class="right topBorder" data-test-id="send-solicitation-dialog-preview-preheader">
                {{ previewPreheader }}
              </div>
            </div>
          }
        </section>
      }
      <div class="preview-body">
        <article
          class="previewBody"
          data-test-id="send-solicitation-dialog-preview-body"
          [innerHTML]="previewEmail?.htmlContent"
        ></article>
      </div>
      <footer>
        <button
          class="button button--secondary"
          data-test-id="send-solicitation-dialog-preview-cancel"
          (click)="clearPreviewEmail()"
        >
          Cancel
        </button>
        <button
          class="button button--primary"
          data-test-id="send-solicitation-dialog-preview-submit"
          [disabled]="sendingEmail"
          (click)="confirmSendAllClickHandler()"
        >
          {{ sendingEmail ? 'sending' : 'Confirm and send all' }}
        </button>
      </footer>
    </div>
  </div>
}
